module.exports = __webpack_public_path__ + "mp3/A_Ghost_Town.mp3";